import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

try {
  const qs = new URLSearchParams(window.location.search);
  const parts = [];
  for (const k of ["utm_source", "utm_medium", "utm_campaign", "utm_content"]) {
    const v = qs.get(k);
    if (v) parts.push(`${k}=${v.slice(0, 60)}`);
  }
  const refCode = qs.get("ref");
  if (refCode) parts.push(`ref=${refCode.slice(0, 60)}`);
  const fpref = qs.get("fpref");
  if (fpref) parts.push(`fpref=${fpref.slice(0, 60)}`);
  if (parts.length) localStorage.setItem("fp_ref", parts.join("|").slice(0, 200));
} catch {}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
